import { HttpClient } from '@angular/common/http';
import { Component, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService, NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';
import { GoogleLoginProvider, SocialAuthService } from 'angularx-social-login';
import * as uuid from 'uuid';
import { ConfirmOperationComponent } from '../../../@theme/components/confirm-operation/confirm-operation.component';
import { ImportFileComponent } from '../../../@theme/components/import-file/import-file.component';
import { ImportUserEmailComponent } from '../../../@theme/components/import-user-email/import-user-email.component';
import { UserService } from './user.service';


@Component({
  selector: 'ngx-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent {

  public users = [];

  items = [
    { title: 'Adicionar manualmente' },
    { title: 'Criar um link de autocadastro para eu compartilhar com eles' },
    { title: 'Importar meus contatos do Google' },
    { title: 'Informar e-mails para a stepapp convidar' },
    { title: 'Importar uma planilha com o nome e e-mail' }
  ];

  settings = {
    actions: {
      columnTitle: 'Ações',
      add: false,
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
    },
    mode: 'external',
    columns: {
      email: {
        title: 'E-mail',
        type: 'string',
      },
      firstName: {
        title: 'Nome',
        type: 'string',
      },
      activatedGrid: {
        title: 'Ativo',
      },
      permissonGrid: {
        title: 'Permissão',
      },
    },
    noDataMessage: 'Nenhum registro encontrado',
  };

  constructor(private userService: UserService, private router: Router, private dialogService: NbDialogService,
    private toastrService: NbToastrService, private authServiceSocial: SocialAuthService,
    private route: ActivatedRoute,
    private http: HttpClient) {
    this.getAllUsers();
  }

  generateLink() {
    const userOwner = this.users.filter(function (user) {
      return user.isOwner;
    });
    if (userOwner) {
      this.copyText(window.location.origin + '/auth/share/' + userOwner[0].id)
    }
  }

  copyText(val: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.toastrService.show('Usuário', 'Link copiado com sucesso!',
      { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
  }

  import() {
    this.dialogService.open(ImportFileComponent, {
      context: {
        title: 'Importação de usuários'
      },
    }).onClose.subscribe(response => {
      location.reload();
    });
  }

  importByEmail() {
    this.dialogService.open(ImportUserEmailComponent, {
      context: {
        title: 'Adicionar usuários'
      },
    }).onClose.subscribe(response => {
      location.reload();
    });
  }


  getAllUsers() {
    this.userService.query().toPromise().then(response => {
      this.users = response.body;
    });
  }

  openCreateDialog() {
    this.router.navigate(['pages/admin/user', 'create']);
  }

  openActivation() {
    this.router.navigate(['pages/admin/user/activation/show']);
  }

  onDeleteConfirm(event): void {

    this.dialogService.open(ConfirmOperationComponent, {
      closeOnBackdropClick: false,
      context: {
        title: 'Excluir Usuário',
        text: `Você realmente deseja excluir o usuário ${event.data.firstName} ?`,
        accent: 'danger',
        force: false,
      },
    }).onClose.subscribe(response => response.confirmed && this.delete(event.data.id));
  }

  delete(id: string) {
    this.userService.delete(id).toPromise().then(response => {
      this.toastrService.show('Usuário', 'Excluído com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.getAllUsers();
    }).catch(err => {
      this.toastrService.show('Usuário', err.error.message,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger', duration: 7000 });

    });
  }

  openEditDialog(event): void {
    this.router.navigate(['pages/admin/user', event.data.id]);
  }

  onCreateConfirm(event): void {
    this.userService.create(event.newData).toPromise().then(respose => {
      event.confirm.resolve(event.newData);
    });
  }

  signInWithGoogle(dialog): void {
    const googleLoginOptions = {
      scope: 'https://www.googleapis.com/auth/contacts'
    };

    this.authServiceSocial.signIn(GoogleLoginProvider.PROVIDER_ID, googleLoginOptions).then(result => {
      const acessToken = result.authToken;
      this.getContatcs(acessToken);
      this.open(dialog);
    });
  }

  getContatcs(acessToken) {
    this.http.get<any>(`https://www.google.com/m8/feeds/contacts/default/full?alt=json&access_token=${acessToken}&max-results=500&v=3.0`).subscribe(data => {
      data.feed.entry[0].link[1].href;
      for (let index = 0; index < data.feed.entry.length; index++) {
        const entry = data.feed.entry[index];
        this.getContactDetail(entry.link[1].href, acessToken);
      }
    });
  }

  searchTerm;

  search() {
    let term = this.searchTerm;
    this.usersCopy = this.usersGoogle.filter(function (tag) {
      return tag.name.indexOf(term) >= 0;
    });
  }

  open(dialog: TemplateRef<any>) {
    this.dialogService.open(dialog, { context: 'this is some additional data passed to dialog' }).onClose.subscribe(result => {
      if (result) {
        this.users = result;
      }
    });
  }

  usersGoogle;
  usersCopy;

  closeDialog(ref) {
    const usersSel = this.usersGoogle.filter(user => user.sel);
    ref.close(usersSel);
  }

  marcarTodos(event) {
    this.usersGoogle.map(user => user.sel = event);
  }

  getContactDetail(href, acessToken) {
    this.usersCopy = [];
    this.http.get<any>(`${href}&alt=json&access_token=${acessToken}`).subscribe(data => {
      if (data.entry.gd$email && data.entry.gd$name) {
        const user: any = {};
        user.email = data.entry.gd$email[0].address
        user.firstName = data.entry.gd$name.gd$fullName.$t;
        user.id = uuid.v4();
        this.usersGoogle.push(user);
        this.usersCopy.push(user);
      }
    });
  }

  sortBy(prop: string) {
    if (this.usersCopy) {
      return this.usersCopy.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
    }
  }

}
